import {Component, Vue, Watch} from 'vue-property-decorator'
import {getStudentStaticData} from '@/api/classManage.ts'
import {
    lastMonth,
    lastQuarter,
    lastWeek, lastYear,
    thisMonth,
    thisQuarter,
    thisToday,
    thisWeek, thisYear,
    thisYesterday
} from "@/utils/dateTime";
import * as echarts from 'echarts';

@Component({})
export default class ClassStudentStaticData extends Vue {
    timeType = '1'
    timeStrDate = []
    timeStr = ''
    startWeek = '' // 本周开始
    endWeek = '' //本周结束
    startMonth = '' // 本月开始
    endMonth = ''  //本月结束
    startLastWeek = '' //上周开始
    endLastWeek = '' //上周结束
    startLastMonth = '' // 上月开始
    endLastMonth = ''  // 上月结束
    startQuarter = ''  // 本季度开始
    endQuarter = '' // 本季度结束
    startLastQuarter = '' //上季度开始
    endLastQuarter = '' //上季度结束
    startYear = '' // 本年开始
    endYear = '' // 本年结束
    today = ''
    yesterday = ''
    yesteryearStart = ''
    yesteryearEnd = ''
    loadingGradeBar = false
    loadingGradePie = false
    loadingMajorBar = false
    loadingMajorPie = false
    loadingTypeBar = false
    loadingTypePie = false
    loadingAddressBar = false
    loadingAddressPie = false
    loadingSouBar = false
    loadingSouPie = false
    projectTypeList = [
        {
            value: 'Path海外',
            label: 'Path海外',
            // disabled: true
        }, {
            value: '青椒科研国内',
            label: '青椒科研国内',
            // disabled: true
        }, {
            value: 'IEPQ',
            label: 'IEPQ',
            // disabled: true
        }, {
            value: '松鼠竞赛',
            label: '松鼠竞赛',
            // disabled: true
        }, {
            value: '其他',
            label: '其他',
            // disabled: true
        }
    ]
    prevSouCourseNameArr = ['all']
    YEYTimeStr = '' // 同比时间

    created() {
        this.getDateInterval()
    }

    get prevSouCourseNameStr() {
        let str
        if (this.prevSouCourseNameArr.includes('all')) {
            this.prevSouCourseNameArr = this.projectTypeList.map(item => item.value)
            str = 'Path海外,青椒科研国内,IEPQ,松鼠竞赛,其他'
        } else {
            str = this.prevSouCourseNameArr.join(',')
        }
        return str
    }

    handleSelectAll() {
        if (this.prevSouCourseNameArr.includes('all')) {
            this.prevSouCourseNameArr = this.projectTypeList.map(item => item.value); // 全选所有选项，不包括'all'自身
        } else {
            this.prevSouCourseNameArr = ['all']; // 只选中全选项，实际应用中可能需要调整逻辑来避免选中'all'自身导致无限循环或逻辑错误。通常不直接选中'all'作为选项。
        }
    }

    //    初始化获取日期区间
    getDateInterval() {
        // 获取今天
        this.today = thisToday();

        // 获取昨天
        this.yesterday = thisYesterday();

        // 本周
        this.startWeek = thisWeek()[0]//周一日期
        this.endWeek = thisWeek()[1];//周日日期

        //上周
        this.startLastWeek = lastWeek()[0]; //周一日期
        this.endLastWeek = lastWeek()[1]; //周日日期

        // 本月
        this.startMonth = thisMonth()[0]
        this.endMonth = thisMonth()[1]

        // 上月
        this.startLastMonth = lastMonth()[0];
        this.endLastMonth = lastMonth()[1];

        // 本季度
        this.startQuarter = thisQuarter()[0];
        this.endQuarter = thisQuarter()[1];

        // 上季度
        this.startLastQuarter = lastQuarter()[0];
        this.endLastQuarter = lastQuarter()[1];

        //本年
        this.startYear = thisYear()[0];
        this.endYear = thisYear()[1];

        // 获取去年
        this.yesteryearStart = lastYear()[0];
        this.yesteryearEnd = lastYear()[1];

        if (this.timeType == '0') {
            this.timeStr = this.yesterday + '&' + this.yesterday
            this.timeStrDate = [this.yesterday, this.yesterday]
            this.getData()
        } else if (this.timeType == '1') {
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today, this.today]
            this.getData()
        } else if (this.timeType == '8') {
            this.timeStr = this.startLastQuarter + '&' + this.endLastQuarter
            this.timeStrDate = [this.startLastQuarter, this.endLastQuarter]
            this.getData()
        }

    }

    changeDateType(val) {
        if (val === '2') {  //    本周
            this.timeStr = this.startWeek + '&' + this.endWeek
            this.timeStrDate = [this.startWeek, this.endWeek]
        } else if (val === '3') { // 本月
            this.timeStr = this.startMonth + '&' + this.endMonth
            this.timeStrDate = [this.startMonth, this.endMonth]
        } else if (val === '4') { // 本季度
            this.timeStr = this.startQuarter + '&' + this.endQuarter
            this.timeStrDate = [this.startQuarter, this.endQuarter]
        } else if (val === '5') { // 本年
            this.timeStr = this.startYear + '&' + this.endYear
            this.timeStrDate = [this.startYear, this.endYear]
        } else if (val === '6') { // 上周
            this.timeStr = this.startLastWeek + '&' + this.endLastWeek
            this.timeStrDate = [this.startLastWeek, this.endLastWeek]
        } else if (val === '7') { // 上月
            this.timeStr = this.startLastMonth + '&' + this.endLastMonth
            this.timeStrDate = [this.startLastMonth, this.endLastMonth]
        } else if (val === '8') { // 上季度
            this.timeStr = this.startLastQuarter + '&' + this.endLastQuarter
            this.timeStrDate = [this.startLastQuarter, this.endLastQuarter]
        } else if (val === '9') { // 去年
            this.timeStr = this.yesteryearStart + '&' + this.yesteryearEnd
            this.timeStrDate = [this.yesteryearStart, this.yesteryearEnd]
        } else if (val === '0') { // 昨天
            this.timeStr = this.yesterday + '&' + this.yesterday
            this.timeStrDate = [this.yesterday, this.yesterday]
        } else if (val === '1') { // 今天
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today, this.today]
        } else {
            this.timeStr = ''
            this.timeStrDate = []
        }

        if (this.timeStr) {
            this.getData()
        }

    }

    handleChangeData(val) {
        const week = [this.startWeek, this.endWeek]
        const month = [this.startMonth, this.endMonth]
        const year = [this.startYear, this.endYear]
        const quarter = [this.startQuarter, this.endQuarter]
        const lastWeek = [this.startLastWeek, this.endLastWeek]
        const lastMonth = [this.startLastMonth, this.endLastMonth]
        const lastQuarter = [this.startLastQuarter, this.endLastQuarter]
        const lastyear = [this.yesteryearStart, this.yesteryearEnd]
        const yesterday = [this.yesterday, this.yesterday]
        const today = [this.today, this.today]
        if (week[0].indexOf(val[0]) !== -1 && week[1].indexOf(val[1]) !== -1) {
            this.timeType = '2'
        } else if (month[0].indexOf(val[0]) !== -1 && month[1].indexOf(val[1]) !== -1) {
            this.timeType = '3'
        } else if (quarter[0].indexOf(val[0]) !== -1 && quarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '4'
        } else if (year[0].indexOf(val[0]) !== -1 && year[1].indexOf(val[1]) !== -1) {
            this.timeType = '5'
        } else if (lastWeek[0].indexOf(val[0]) !== -1 && lastWeek[1].indexOf(val[1]) !== -1) {
            this.timeType = '6'
        } else if (lastMonth[0].indexOf(val[0]) !== -1 && lastMonth[1].indexOf(val[1]) !== -1) {
            this.timeType = '7'
        } else if (lastQuarter[0].indexOf(val[0]) !== -1 && lastQuarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '8'
        } else if (lastyear[0].indexOf(val[0]) !== -1 && lastyear[1].indexOf(val[1]) !== -1) {
            this.timeType = '9'
        } else if (yesterday[0].indexOf(val[0]) !== -1 && yesterday[1].indexOf(val[1]) !== -1) {
            this.timeType = '0'
        } else if (today[0].indexOf(val[0]) !== -1 && today[1].indexOf(val[1]) !== -1) {
            this.timeType = '1'
        } else {
            this.timeType = '自定义时间'
        }
        this.timeStr = val[0] + '&' + val[1]
        this.getData()
    }

    //  获取统计图
    getData() {
        this.getStudentGradeData() // 年级
        this.getStudentGradeDataYEY() // 年级同比

        this.getStudentMajorData() // 专业
        this.getStudentMajorDataYEY() // 专业

        this.getStudentTypeData() // 类型
        this.getStudentTypeDataYEY() // 类型

        this.getStudentAdressData() // 升学需求
        this.getStudentAdressDataYEY() // 升学需求

        this.getStudentSouCourseData() // 报名项目类型
        this.getStudentSouCourseDataYEY() // 报名项目类型
    }

    /*
    * 单独获取年级数据*/
    async getStudentGradeData() {
        this.loadingGradeBar = true
        const obj = {
            timeStr: this.timeStr,
            groupByType: '0',//年级
            prevSouCourseNameStr: this.prevSouCourseNameStr,
        }
        const data: any = await getStudentStaticData(obj)

        const pieData = data.studentStatisticalData.map(item => ({
                value: item.count,
                name: item.group
            }
        ))

        let sum2 = 0
        pieData.forEach((item, index) => {
            sum2 += Number(item.value)
        })

        const chartDom: any = document.getElementById('student-grade-bar');
        const myChart = echarts.init(chartDom);
        let option;
        if (pieData.length == 0) {
            option = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                },
                series: {
                    data: pieData,
                }
            }
        } else {
            option = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    show: false,
                },
                series: [
                    {
                        data: pieData,
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        labelLine: {
                            show: true
                        },
                        labelLayout: {
                            hideOverlap: false
                        },
                        label: {
                            show: true,
                            position: 'outside',
                            align: 'center',
                            fontSize: 10,
                            formatter: (params) => {
                                let str = params.data.name + '\n'
                                if (params.data.value > 0) {
                                    str += '占比' + (params.data.value / sum2 * 100).toFixed(2) + '%'
                                } else {
                                    str += '0%'
                                }
                                return str
                            }
                        },
                    }
                ]
            };
        }

        option && myChart.setOption(option)
        this.loadingGradeBar = false


    }

    /*年级同比*/
    async getStudentGradeDataYEY() {
        this.YEYTimeStr = this.handleTime()
        this.loadingGradePie = true

        const obj = {
            timeStr: this.YEYTimeStr,
            groupByType: '0',//年级
            prevSouCourseNameStr: this.prevSouCourseNameStr,
        }
        const data: any = await getStudentStaticData(obj)

        const pieData = data.studentStatisticalData.map(item => ({
                value: item.count,
                name: item.group
            }
        ))

        let sum2 = 0
        pieData.forEach((item, index) => {
            sum2 += Number(item.value)
        })

        /*
     * 饼状图*/
        const chartDomPie = document.getElementById('student-grade-pie');
        const myStudentPieChart = echarts.init(chartDomPie);
        let optionStudentPie;
        if (pieData.length == 0) {
            optionStudentPie = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                },
                series: {
                    data: pieData,
                }
            }
        } else {
            optionStudentPie = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'item'
                },
                // 图例组件
                legend: {
                    show: false,
                },
                series: [
                    {
                        name: '年级',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 14,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        data: pieData,
                        labelLayout: {
                            hideOverlap: false
                        },
                        label: {
                            show: true,
                            position: 'outside',
                            align: 'center',
                            fontSize: 10,
                            formatter: (params) => {
                                let str = params.data.name + '\n'
                                if (params.data.value > 0) {
                                    str += '占比' + (params.data.value / sum2 * 100).toFixed(2) + '%'
                                } else {
                                    str += '0%'
                                }
                                return str
                            }
                        },
                    }
                ]
            };
        }
        optionStudentPie && myStudentPieChart.setOption(optionStudentPie);
        this.loadingGradePie = false
    }

    /*
  * 单独获取学生专业数据*/
    async getStudentMajorData() {
        this.loadingMajorBar = true

        const obj = {
            timeStr: this.timeStr,
            groupByType: '1',//专业
            prevSouCourseNameStr: this.prevSouCourseNameStr,
        }
        await getStudentStaticData(obj).then((data: any) => {

            const pieData = data.studentStatisticalData.map(item => ({
                    value: item.count,
                    name: item.group
                }
            ))
            let sum2 = 0
            pieData.forEach((item, index) => {
                sum2 += Number(item.value)
            })

            const chartDom = document.getElementById('student-major-bar');
            const myChart = echarts.init(chartDom);
            let option;
            if (pieData.length == 0) {
                option = {
                    title: {
                        text: '暂无数据',
                        x: 'center',
                        y: 'center',
                        textStyle: {
                            fontSize: 14,
                            fontWeight: 'normal',
                        }
                    },
                    series: {
                        data: pieData,
                    }
                }
            } else {
                option = {
                    title: {
                        text: '',
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    // 图例组件
                    legend: {
                        show: false,
                    },
                    series: [
                        {
                            data: pieData,
                            type: 'pie',
                            radius: ['40%', '70%'],
                            avoidLabelOverlap: false,
                            labelLine: {
                                show: true
                            },
                            labelLayout: {
                                hideOverlap: false
                            },
                            label: {
                                show: true,
                                position: 'outside',
                                align: 'center',
                                fontSize: 10,
                                formatter: (params) => {
                                    let str = params.data.name + '\n'
                                    if (params.data.value > 0) {
                                        str += '占比' + (params.data.value / sum2 * 100).toFixed(2) + '%'
                                    } else {
                                        str += '0%'
                                    }
                                    return str
                                }
                            },
                        }
                    ]
                };
            }
            myChart.setOption(option)
            this.loadingMajorBar = false
        })
    }

    async getStudentMajorDataYEY() {
        this.YEYTimeStr = this.handleTime()
        this.loadingMajorPie = true
        const obj = {
            timeStr: this.YEYTimeStr,
            groupByType: '1',//专业
            prevSouCourseNameStr: this.prevSouCourseNameStr,
        }
        const data: any = await getStudentStaticData(obj)

        const pieData = data.studentStatisticalData.map(item => ({
                value: item.count,
                name: item.group
            }
        ))
        let sum2 = 0
        pieData.forEach((item, index) => {
            sum2 += Number(item.value)
        })

        /*
      * 学生专业饼状图*/
        const chartDomPie = document.getElementById('student-major-pie');
        const myStudentPieChart = echarts.init(chartDomPie);
        let optionStudentPie;
        if (pieData.length == 0) {
            optionStudentPie = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                },
                series: {
                    data: pieData,
                }
            }
        } else {
            optionStudentPie = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'item'
                },
                // 图例组件
                legend: {
                    show: false,
                },
                series: [
                    {
                        name: '专业',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 14,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true,
                        },
                        labelLayout: {
                            hideOverlap: false
                        },
                        data: pieData,
                        label: {
                            show: true,
                            position: 'outside',
                            avoidLabelOverlap: true,
                            // formatter:'{b}: {c} ({d}%)', // {b}: 名称, {c}: 值, {d}: 百分比
                            // rotate:45,// 旋转标签，避免重叠
                            // align: 'center',
                            fontSize: 10,
                            formatter: (params) => {
                                let str = params.data.name + '\n'
                                if (params.data.value > 0) {
                                    str += '占比' + (params.data.value / sum2 * 100).toFixed(2) + '%'
                                } else {
                                    str += '0%'
                                }
                                return str
                            }
                        },
                    }
                ]
            };
        }
        optionStudentPie && myStudentPieChart.setOption(optionStudentPie);
        this.loadingMajorPie = false
    }

    /*
  * 单独获取学生类型数据*/
    async getStudentTypeData() {
        this.loadingTypeBar = true
        const obj = {
            timeStr: this.timeStr,
            groupByType: '2',//类型
            prevSouCourseNameStr: this.prevSouCourseNameStr,
        }
        const data: any = await getStudentStaticData(obj)

        const pieData = data.studentStatisticalData.map(item => ({
                value: item.count,
                name: item.group
            }
        ))

        let sum2 = 0
        pieData.forEach((item, index) => {
            sum2 += Number(item.value)
        })

        /*
       * 类型柱状统计图
       * */

        const chartDom = document.getElementById('student-type-bar');
        const myChart = echarts.init(chartDom);
        let option;
        if (pieData.length == 0) {
            option = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                },
                series: {
                    data: pieData,
                }
            }
        } else {
            option = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'item'
                },
                // 图例组件
                legend: {
                    show: false,
                },
                series: [
                    {
                        data: pieData,
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        labelLine: {
                            show: true
                        },
                        labelLayout: {
                            hideOverlap: false
                        },
                        label: {
                            show: true,
                            position: 'outside',
                            align: 'center',
                            fontSize: 10,
                            formatter: (params) => {
                                let str = params.data.name + '\n'
                                if (params.data.value > 0) {
                                    str += '占比' + (params.data.value / sum2 * 100).toFixed(2) + '%'
                                } else {
                                    str += '0%'
                                }
                                return str
                            }
                        },
                    }
                ]
            };
        }
        option && myChart.setOption(option)
        this.loadingTypeBar = false

    }

    async getStudentTypeDataYEY() {
        this.YEYTimeStr = this.handleTime()
        this.loadingTypePie = true
        const obj = {
            timeStr: this.YEYTimeStr,
            groupByType: '2',//类型
            prevSouCourseNameStr: this.prevSouCourseNameStr,
        }
        const data: any = await getStudentStaticData(obj)


        const pieData = data.studentStatisticalData.map(item => ({
                value: item.count,
                name: item.group
            }
        ))

        let sum2 = 0
        pieData.forEach((item, index) => {
            sum2 += Number(item.value)
        })

        /*
        * 饼状图*/
        const chartDomPie = document.getElementById('student-type-pie');
        const myStudentPieChart = echarts.init(chartDomPie);
        let optionStudentPie;
        if (pieData.length == 0) {
            optionStudentPie = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                },
                series: {
                    data: pieData,
                }
            }
        } else {
            optionStudentPie = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'item'
                },
                // 图例组件
                legend: {
                    show: false,
                },
                series: [
                    {
                        name: '类型',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 14,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        data: pieData,
                        labelLayout: {
                            hideOverlap: false
                        },
                        label: {
                            show: true,
                            position: 'outside',
                            align: 'center',
                            fontSize: 10,
                            formatter: (params) => {
                                let str = params.data.name + '\n'
                                if (params.data.value > 0) {
                                    str += '占比' + (params.data.value / sum2 * 100).toFixed(2) + '%'
                                } else {
                                    str += '0%'
                                }
                                return str
                            }
                        },
                    }
                ]
            };
        }
        optionStudentPie && myStudentPieChart.setOption(optionStudentPie);
        this.loadingTypePie = false
    }

    /*
  * 单独获取升学需求数据*/
    async getStudentAdressData() {
        this.loadingAddressBar = true
        const obj = {
            timeStr: this.timeStr,
            groupByType: '3',//地区
            prevSouCourseNameStr: this.prevSouCourseNameStr,
        }
        const data: any = await getStudentStaticData(obj)

        const pieData = data.studentStatisticalData.map(item => ({
                value: item.count,
                name: item.group
            }
        ))

        let sum2 = 0
        pieData.forEach((item, index) => {
            sum2 += Number(item.value)
        })

        /*
       * 留学地区柱状统计图
       * */

        const chartDom = document.getElementById('student-address-bar');
        const myChart = echarts.init(chartDom);
        let option;
        if (pieData.length == 0) {
            option = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                },
                series: {
                    data: pieData,
                }
            }
        } else {
            option = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'item'
                },
                // 图例组件
                legend: {
                    show: false,
                },
                series: [
                    {
                        data: pieData,
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        labelLine: {
                            show: true
                        },
                        labelLayout: {
                            hideOverlap: false
                        },
                        label: {
                            show: true,
                            position: 'outside',
                            align: 'center',
                            fontSize: 10,
                            formatter: (params) => {
                                let str = params.data.name + '\n'
                                if (params.data.value > 0) {
                                    str += '占比' + (params.data.value / sum2 * 100).toFixed(2) + '%'
                                } else {
                                    str += '0%'
                                }
                                return str
                            }
                        },
                    }
                ]
            };
        }

        option && myChart.setOption(option)
        this.loadingAddressBar = false

    }

    async getStudentAdressDataYEY() {
        this.YEYTimeStr = this.handleTime()
        this.loadingAddressPie = true
        const obj = {
            timeStr: this.YEYTimeStr,
            groupByType: '3',//地区
            prevSouCourseNameStr: this.prevSouCourseNameStr,
        }
        const data: any = await getStudentStaticData(obj)

        const pieData = data.studentStatisticalData.map(item => ({
                value: item.count,
                name: item.group
            }
        ))

        let sum2 = 0
        pieData.forEach((item, index) => {
            sum2 += Number(item.value)
        })

        /*
        * 饼状图*/
        const chartDomPie = document.getElementById('student-address-pie');
        const myStudentPieChart = echarts.init(chartDomPie);
        let optionStudentPie;
        if (pieData.length == 0) {
            optionStudentPie = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                },
                series: {
                    data: pieData,
                }
            }
        } else {
            optionStudentPie = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'item'
                },
                // 图例组件
                legend: {
                    show: false,
                },
                series: [
                    {
                        name: '升学需求',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 14,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        data: pieData,
                        labelLayout: {
                            hideOverlap: false
                        },
                        label: {
                            show: true,
                            position: 'outside',
                            align: 'center',
                            fontSize: 10,
                            formatter: (params) => {
                                let str = params.data.name + '\n'
                                if (params.data.value > 0) {
                                    str += '占比' + (params.data.value / sum2 * 100).toFixed(2) + '%'
                                } else {
                                    str += '0%'
                                }
                                return str
                            }
                        },
                    }
                ]
            };
        }
        optionStudentPie && myStudentPieChart.setOption(optionStudentPie);
        this.loadingAddressPie = false
    }

    /*
  * 单独报名项目类型数据*/
    async getStudentSouCourseData() {
        this.loadingSouBar = true

        const obj = {
            timeStr: this.timeStr,
            groupByType: '4',//报名项目类型
            prevSouCourseNameStr: this.prevSouCourseNameStr,
        }
        const data: any = await getStudentStaticData(obj)

        const pieData = data.studentStatisticalData.map(item => ({
                value: item.count,
                name: item.group
            }
        ))

        let sum2 = 0
        pieData.forEach((item, index) => {
            sum2 += Number(item.value)
        })

        /*
       * 报名项目类型柱状统计图
       * */

        const chartDom = document.getElementById('student-souCourse-bar');
        const myChart = echarts.init(chartDom);
        let option;
        if (pieData.length == 0) {
            option = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                },
                series: {
                    data: pieData,
                }
            }
        } else {
            option = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'item'
                },
                // 图例组件
                legend: {
                    show: false,
                },
                series: [
                    {
                        data: pieData,
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        labelLine: {
                            show: true
                        },
                        labelLayout: {
                            hideOverlap: false
                        },
                        label: {
                            show: true,
                            position: 'outside',
                            align: 'center',
                            fontSize: 10,
                            formatter: (params) => {
                                let str = params.data.name + '\n'
                                if (params.data.value > 0) {
                                    str += '占比' + (params.data.value / sum2 * 100).toFixed(2) + '%'
                                } else {
                                    str += '0%'
                                }
                                return str
                            }
                        },
                    }
                ]
            };
        }
        option && myChart.setOption(option)
        this.loadingSouBar = false

    }

    async getStudentSouCourseDataYEY() {
        this.YEYTimeStr = this.handleTime()
        this.loadingSouPie = true
        const obj = {
            timeStr: this.YEYTimeStr,
            groupByType: '4',//报名项目类型
            prevSouCourseNameStr: this.prevSouCourseNameStr,
        }
        const data: any = await getStudentStaticData(obj)

        const pieData = data.studentStatisticalData.map(item => ({
                value: item.count,
                name: item.group
            }
        ))

        let sum2 = 0
        pieData.forEach((item, index) => {
            sum2 += Number(item.value)
        })

        /*
        * 饼状图*/
        const chartDomPie = document.getElementById('student-souCourse-pie');
        const myStudentPieChart = echarts.init(chartDomPie);
        let optionStudentPie;
        if (pieData.length == 0) {
            optionStudentPie = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                },
                series: {
                    data: pieData,
                }
            }
        } else {
            optionStudentPie = {
                title: {
                    text: ' ',
                },
                tooltip: {
                    trigger: 'item'
                },
                // 图例组件
                legend: {
                    show: false,
                },
                series: [
                    {
                        name: '报名项目类型',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 14,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        data: pieData,
                        labelLayout: {
                            hideOverlap: false
                        },
                        label: {
                            show: true,
                            position: 'outside',
                            align: 'center',
                            fontSize: 10,
                            formatter: (params) => {
                                let str = params.data.name + '\n'
                                if (params.data.value > 0) {
                                    str += '占比' + (params.data.value / sum2 * 100).toFixed(2) + '%'
                                } else {
                                    str += '0%'
                                }
                                return str
                            }
                        },
                    }
                ]
            };
        }

        optionStudentPie && myStudentPieChart.setOption(optionStudentPie);
        this.loadingSouPie = false
    }

    changeProjectType(val) {
        if (val.length > 0) {
            this.getData()
        } else {
            this.$message.warning('产品类型不可为空！')
        }
    }


    handleTime() {
        // 日期减去一年
        const dates = [new Date(this.timeStrDate[0]), new Date(this.timeStrDate[1])];

        dates.forEach(date => {
            date.setFullYear(date.getFullYear() - 1);
        });
        // 日期转字符串
        const dateStrings = dates.map(date => date.toISOString().slice(0, 10));

        return dateStrings.join('&')
    }

    @Watch('prevSouCourseNameArr')
    handlePrevSouCourseNameArr(oVal, nVal) {
        /*数组转字符串*/
        if (nVal.split !== oVal.split) {
            // if (nVal.split.indexOf('全部') !== -1) {
            //     // disabled: true
            // }
            /*判断数组是否包含某个值*/
            // if (nVal.indexOf('全部') !== -1) {
            //     this.prevSouCourseNameArr = ['全部']
            // } else {
            //     this.prevSouCourseNameArr = nVal
            // }
        }
    }
}